import { createFileRoute } from '@tanstack/react-router';
import { SubjectsList } from '@/components';

const SubjectsIndexPage = () => {
  const { areaSlug } = Route.useParams();
  return <SubjectsList areaSlug={areaSlug} />;
};

export const Route = createFileRoute('/_adminLayout/admin/areas/$areaSlug/subjects/')({
  component: SubjectsIndexPage
});
